export default "__VITE_ASSET__913adffa__"